import fromAnyToString from 'utils/converters/fromAnyToString';
import { fromPropsToPathSegments } from 'utils/converters/props/path.util';
import logger from 'utils/logger.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';

const L = logger('editPathSegments');

const editPathSegments = (fn, props) => {
  if (isNotFn(fn)) {
    L.error('()', fn, 'is not a function', 'returning empty string');
    return '';
  }

  const segments = fromPropsToPathSegments(props);
  const result = fn(segments);
  return Array.isArray(result) ? result.join('/') : fromAnyToString(result);
};

// noinspection JSUnusedGlobalSymbols
export default editPathSegments;
